/*
 * ---license-start---
 * Solar Orbiter Science Operations software
 * ----
 * Copyright (C) 2012 - 2018 European Space Agency - Solar Orbiter SOC
 * ----
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Lesser Public License for more details.
 *
 * You should have received a copy of the GNU General Lesser Public
 * License along with this program.  If not, see
 * <http://www.gnu.org/licenses/lgpl-3.0.html>.
 * ---license-end---
 */
(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('wait', wait);

    wait.$inject = [];

    function wait() {
        return {
            template: '<div id="contain"><h2>...Loading....</h2>\n' +
                '    <div class=\'wrap\' id=\'wrap1\'>\n' +
                '        <div class=\'ball\' id=\'ball1\'></div>\n' +
                '    </div>\n' +
                '    <div class=\'wrap\' id=\'wrap2\'>\n' +
                '        <div class=\'ball\' id=\'ball2\'></div>\n' +
                '    </div>\n' +
                '    <div class=\'wrap\' id=\'wrap3\'>\n' +
                '        <div class=\'ball\' id=\'ball3\'></div>\n' +
                '    </div>\n' +
                '    <div class=\'wrap\' id=\'wrap4\'>\n' +
                '        <div class=\'ball\' id=\'ball4\'></div>\n' +
                '    </div></div>'
        };
    }
})();
